var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Button as MuiButton, } from '@mui/material';
import styles from './Button.module.scss';
export const Variants = ['primary', 'secondary', 'tertiary', 'link'];
export const Sizes = ['sm', 'md', 'lg', 'xl', 'xxl'];
const Button = React.forwardRef((_a, ref) => {
    var { children, variant = 'primary', label, color, destructive, size = 'sm', className } = _a, props = __rest(_a, ["children", "variant", "label", "color", "destructive", "size", "className"]);
    const isPrimary = variant === Variants[0];
    const isTertiary = variant === Variants[2];
    const isLink = variant === Variants[3];
    const variantColor = !isPrimary && color ? `${variant}Color` : variant;
    const destructiveVariant = `${isTertiary || isLink ? variant : variantColor}Destructive`;
    return (React.createElement(MuiButton, Object.assign({ ref: ref, className: [
            styles.common,
            destructive ? styles[destructiveVariant] : styles[variantColor],
            styles[size],
            className,
        ].join(' ') }, props, { disableRipple: true }), label || children));
});
export default Button;
